import IconBox from "../../IconBox"
import { OperationDetailsProps } from "../props"
import {
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailValue,
  IconContainer,
  ScrollContainer,
  SourceDescription,
  StatusChecked,
  StyledDivider,
  Subtext,
  TopContainer,
} from "../styled"
import UIIcon from "../../UIIcon"
import SBPIconNoExt from "../../SBPIconNoExt"
import { formatAmount } from "../../../utils/formatters"
import { RUBLE } from "../../../utils/constants"
import { getOperationDirection, getOperationStatusDetails } from "../../../utils/operation"
import { getTimezone } from "../../../utils/datetime"


const SbpPaymentHistoryDetails = ({
  operation,
  direction,
}: OperationDetailsProps) => {
  const isIncome = direction === 'income'
  const iconName = isIncome ? "incomeGrey" : "outcomeGrey"
  const statusDetails = getOperationStatusDetails(operation)
  const merchantBrandName = operation.fields.find((f) => f.name === "RecipientMerchantBrandName")
  const payerAccountNumber = operation.fields.find((f) => f.name === "PayerAccountNumber")
  const recipientAccountNumber = operation.fields.find((f) => f.name === "RecipientAccountNumber")
  const recipientLegalName = operation.fields.find((f) => f.name === "RecipientLegalName")
  const payerLegalName = operation.fields.find((f) => f.name === "PayerLegalName")
  const recipientBankName = operation.fields.find((f) => f.name === "RecipientBankName")
  const payerBankName = operation.fields.find((f) => f.name === "PayerBankName")
  const description = operation.fields.find((f) => f.name === "Description")
  const operationNumber = operation.fields.find((f) => f.name === "OperationNumber")

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg" color="yellow">
            <UIIcon
              iconName={
                statusDetails.isSuccesseful ? iconName : statusDetails.icon
              }
              size={80}
            />
          </IconBox>
          <SourceDescription>
            {merchantBrandName?.value || ""}
          </SourceDescription>
          <Amount>
            {getOperationDirection(operation)}
            {formatAmount(operation.amount)} {RUBLE}
          </Amount>
          <Subtext>
            {getTimezone(operation.createdOn)}
          </Subtext>
        </TopContainer>

        <StyledDivider />

        <DetailsContainer>
          <DetailContainer>
            <DetailLabel>Статус операции</DetailLabel>
            <DetailValue>
              <StatusChecked statusColor={statusDetails.color}>
                {statusDetails.message}
              </StatusChecked>
            </DetailValue>
          </DetailContainer>
          <DetailContainer>
            <DetailLabel>{isIncome ? "Счет зачисления" : "Счет списания"}</DetailLabel>
            <DetailValue>{isIncome ? recipientAccountNumber?.value || '****' : payerAccountNumber?.value || '****'}</DetailValue>
          </DetailContainer>
          <DetailContainer>
            <DetailLabel>{isIncome ? "Отправитель" : "Получатель"}</DetailLabel>
            <DetailValue>{isIncome ? payerLegalName?.value : recipientLegalName?.value}</DetailValue>
          </DetailContainer>
          <DetailContainer>
            <DetailLabel>{isIncome ? "Банк отправителя" : "Банк получателя"}</DetailLabel>
            <DetailValue>{isIncome ? payerBankName?.value : recipientBankName?.value}</DetailValue>
          </DetailContainer>
          {description?.value && (
            <DetailContainer>
              <DetailLabel>Назначение платежа</DetailLabel>
              <DetailValue>{description?.value}</DetailValue>
            </DetailContainer>
          )}
          {operationNumber?.value && (
            <DetailContainer>
            <DetailLabel>Идентификатор операции</DetailLabel>
            <DetailValue>{operationNumber?.value}</DetailValue>
          </DetailContainer>
          )}
        </DetailsContainer>
        <IconContainer>
          <SBPIconNoExt size={60} />
        </IconContainer>
      </ScrollContainer>
    </ContentContainer>
  )

}

export default SbpPaymentHistoryDetails